import React, { useEffect, useState } from "react";
import {
  AutocompleteInput,
  DateInput,
  minValue,
  NumberInput,
  ReferenceInput,
  required,
  SimpleForm,
  useDataProvider,
} from "react-admin";
import { useRemoveSlot, useSaveSlot, useGetSlot } from "./RefreshMachineStatus";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Box,
  FormControlLabel,
  Switch,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import {
  deleteDoc,
  deleteField,
  doc,
  getDoc,
  setDoc,
  Timestamp,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase";
import ProductForm from "./ProductForm";
import _extendLayout from "../../layout/_extendLayout";
import DeleteIcon from "@material-ui/icons/Delete";
import { toast } from "react-toastify";
import { useForm, useWatch, FormProvider } from "react-hook-form";
import { parse } from "date-fns";

const getSlotNum = (machineSlot) => {
  const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const GRID_COL_NUM = 12;
  const row = parseInt(machineSlot / GRID_COL_NUM);
  const column = machineSlot % GRID_COL_NUM;
  if (column === 0) return `${ALPHABET[row - 1]}${column + 12}`;
  return `${ALPHABET[row]}${column}`;
};

const quantityExceedCapacity = (msg) => (value, values) => {
  const { maxCapacity } = values;
  if (value > maxCapacity) {
    return msg || "Invalid";
  }
};

const SlotEdit = () => {
  const { machineId, slotNumber, boardId } = useParams();
  const { saving, save } = useSaveSlot();
  const { removing, remove } = useRemoveSlot(machineId, slotNumber);
  const slotLabel = getSlotNum(slotNumber);
  const [slotDetails, setSlotDetails] = useState({});
  console.log(slotDetails, "slotDetails");
  const [machineRecord, setMachineRecord] = useState(null);
  const [dirtyFields, setDirtyFields] = useState({});
  const [modified, setModified] = useState(false);
  const [mroAccess, setMROAccess] = useState([]);
  const [productRecord, setProductRecord] = useState(null);
  const [selectedProductId, setSelectedProductId] = useState(
    slotDetails?.product?.id || null,
  );
  const [dropSensor, setDropSensor] = useState(slotDetails?.dropSensor ?? true);
  const [error, setError] = useState(slotDetails?.error ?? false);
  const [price, setPrice] = useState(slotDetails?.price ?? false);
  const [formKey, setFormKey] = useState(Date.now());
  const navigate = useNavigate();
  const dataProvider = useDataProvider();
  const { data: slotRecord, loaded: slotLoaded } = useGetSlot(
    machineId,
    slotNumber,
  );
  // const form = useForm();
  // const productId = useWatch({ name: 'product.id', control: form.control });
  const currentMachineMode = machineRecord?.machineMode;
  const isCreate = slotRecord ? false : true;
  const productForm = useForm();

  const getCalculatedItemNumber = () => {
    const calculated = parseInt(slotNumber);
    return calculated;
  };

  const getItemNumber = () => {
    if (
      slotDetails?.itemNumber !== undefined &&
      slotDetails?.itemNumber !== null
    ) {
      return slotDetails.itemNumber;
    }
    return getCalculatedItemNumber(slotNumber);
  };
  useEffect(() => {
    if (!machineId) return;
    getSlotRecord();
    getMachineData();
  }, [machineId]);

  const getMachineData = async () => {
    try {
      const res = await dataProvider.getOne("machines", { id: machineId });
      setMachineRecord(res.data);
    } catch (err) {
      console.log("error: ", err);
    }
  };

  const getSlotRecord = async () => {
    try {
      const slotDocRef = doc(db, `machines/${machineId}/slots/${slotNumber}`);
      const slotDoc = await getDoc(slotDocRef);
      if (slotDoc.exists()) {
        setSlotDetails(slotDoc.data());
        setSelectedProductId(slotDoc.data()?.product?.id || null);
        setDropSensor(slotDoc.data().dropSensor);
        setError(slotDoc.data().error);
        setPrice(slotDoc.data().price);
      } else {
        setSlotDetails({});
        setSelectedProductId(null);
      }
    } catch (err) {
      console.log("Error fetching machine record");
    }
  };
  const onSubmit = async (data) => {
    const productFormValues = productForm.getValues();
    let productObj = {
      id: data.product.id,
      name: productRecord?.name,
      category: productRecord?.category,
      description: productRecord?.description ?? "",
      image: {
        src: productRecord?.image?.src ?? "",
      },
      mroAccessGroup: mroAccess,
      //  priceCash: productFormValues.product?.priceCash ?? 0,
      //priceCredit: productFormValues?.priceCredit ?? 0,
    };
    let obj = {
      dropSensor: dropSensor ?? true,
      error: error ?? false,
      price: price ?? false,
      itemNumber: data.itemNumber,
      maxCapacity: data.maxCapacity,
      minCapacity: data.minCapacity,
      machineSlot: parseInt(slotNumber),
      expiryDate: data.expiryDate
        ? Timestamp.fromDate(
            data.expiryDate instanceof Date
              ? data.expiryDate
              : data.expiryDate.toDate
                ? data.expiryDate.toDate()
                : new Date(data.expiryDate),
          )
        : null,
      product: productObj,
      totalQuantity: data.totalQuantity,
    };
    const priceCash = price
      ? productFormValues.product?.priceCash
      : productRecord?.priceCash;
    productObj.priceCash = priceCash ?? 0;
    if (currentMachineMode === "mro") {
      productObj.priceCash = price
        ? productFormValues.product?.priceCash
        : productRecord?.priceCash;
      productObj.priceCredit =
        (price
          ? productFormValues.product?.priceCredit
          : productRecord?.priceCredit) ?? 0;
    }
    try {
      const path = `/machines/${machineId}/slots/${slotNumber}`;
      const slotDocRef = doc(db, path);

      if (
        data.expiryDate === null ||
        data.expiryDate === "" ||
        data.expiryDate === undefined
      ) {
        obj.expiryDate = deleteField();
      } else {
        const rawDate =
          data.expiryDate instanceof Timestamp
            ? data.expiryDate.toDate()
            : data.expiryDate instanceof Date
              ? data.expiryDate
              : new Date(data.expiryDate);

        rawDate.setHours(23, 59, 59, 999);

        if (!isNaN(rawDate.getTime())) {
          obj.expiryDate = Timestamp.fromDate(rawDate);
        }
      }
      await setDoc(
        slotDocRef,
        {
          ...obj,
          product: {
            ...productObj,
          },
        },
        { merge: true },
      );
      toast.success("Element has been saved successfully updated");
      setTimeout(() => {
        navigate(`/machines/edit/${machineId}`);
      }, 500);
    } catch (err) {
      console.error("Error saving slot data:", err);
    }
  };

  const onRemove = async () => {
    try {
      const slotDocRef = doc(db, `machines/${machineId}/slots/${slotNumber}`);
      await deleteDoc(slotDocRef);

      toast.success("Slot removed successfully");
      navigate(`/machines/edit/${machineId}`);
    } catch (error) {
      console.error("Error deleting slot:", error);
      toast.error("Failed to remove the slot. Please try again.");
    }
  };

  const handleClearExpiryDate = () => {
    setSlotDetails((prev) => ({
      ...prev,
      expiryDate: null,
    }));
    setFormKey(Date.now());
  };

  const handleOnFieldChange = (field, newValue) => {
    const oldValue = slotDetails[field];

    if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
      setDirtyFields((prev) => ({ ...prev, [field]: true }));
      setModified(true);
    } else {
      const updated = { ...dirtyFields };
      delete updated[field];
      setDirtyFields(updated);
      setModified(Object.keys(updated).length > 0);
    }
  };

  const handleMROAccessChange = (updatedValues) => {
    setMROAccess(updatedValues);
  };

  const handleProductRecordChange = (newProductRecord) => {
    setProductRecord(newProductRecord); // Update state in SlotEdit
  };

  const handleProductChange = (value) => {
    setSelectedProductId(value);
  };

  const expiryDate = slotDetails?.expiryDate?.seconds
    ? new Date(slotDetails.expiryDate.seconds * 1000)
    : null;

  // useEffect(() => {
  //     if (!slotDetails || !slotDetails.product?.id) return;

  //     form.reset({
  //         ...slotDetails,
  //         expiryDate,
  //         product: {
  //             ...(slotDetails.product || {}),
  //             id: slotDetails.product.id,
  //         }
  //     });

  //     form.setValue("product.id", slotDetails.product.id)
  //     console.log("✅ Reset form with:", {
  //         ...slotDetails,
  //         expiryDate,
  //         product: {
  //             ...(slotDetails.product || {}),
  //             id: slotDetails.product.id,
  //         }
  //     });
  // }, [slotDetails])
  if (!slotLoaded) {
    return <div>Loading...</div>;
  }
  return (
    <>
      <_extendLayout>
        <div className="listMachines">
          <CardHeader title={`Edit Slot ${slotLabel}`} />
          <CardHeader title="Slot Details" />
          <SimpleForm
            key={formKey}
            // form={form}
            toolbar={null}
            initialValues={{
              ...slotDetails,
              expiryDate: expiryDate,
            }}
            onSubmit={onSubmit}
          >
            <CardContent style={{ width: "100%" }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <NumberInput
                    label="Item number (display to user)"
                    source="itemNumber"
                    fullWidth
                    validate={[
                      required("Please enter an item number"),
                      minValue(0, "Please enter at least 0"),
                    ]}
                    defaultValue={getItemNumber()}
                  />
                  <input
                    type="hidden"
                    name="machineSlot"
                    value={parseInt(slotNumber)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <NumberInput
                    source="maxCapacity"
                    fullWidth
                    validate={[
                      required("Please enter a max capacity number."),
                      minValue(0, "Please enter at least 0"),
                    ]}
                    defaultValue={slotDetails?.maxCapacity || 10}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <NumberInput
                    label="Current Quantity"
                    source="totalQuantity"
                    fullWidth
                    validate={[
                      required("Please enter a quantity number."),
                      quantityExceedCapacity(
                        "Quantity cannot exceed the max capacity.",
                      ),
                      minValue(0, "Please enter at least 0"),
                    ]}
                    defaultValue={slotDetails?.totalQuantity}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <NumberInput
                    label="Min Capacity"
                    source="minCapacity"
                    fullWidth
                    validate={[
                      quantityExceedCapacity(
                        "Quantity cannot exceed the max capacity.",
                      ),
                      minValue(0, "Please enter at least 0"),
                    ]}
                    defaultValue={slotDetails?.minCapacity}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <div style={{ flex: 1 }}>
                      <DateInput
                        label="Expiry Date"
                        source="expiryDate"
                        helperText={false}
                        fullWidth
                        defaultValue={
                          expiryDate
                            ? new Date(expiryDate).toISOString().split("T")[0]
                            : undefined
                        }
                        parse={(value) =>
                          value ? Timestamp.fromDate(new Date(value)) : ""
                        }
                        inputProps={{
                          min: new Date().toISOString().split("T")[0],
                        }}
                      />
                      {(() => {
                        const rawDate = slotDetails?.expiryDate;
                        let expired = false;

                        if (rawDate) {
                          const expiry = new Date(
                            rawDate.seconds ? rawDate.seconds * 1000 : rawDate,
                          );
                          const today = new Date();
                          expiry.setHours(0, 0, 0, 0);
                          today.setHours(0, 0, 0, 0);
                          expired = expiry < today;
                        }

                        if (expired) {
                          return (
                            <div
                              style={{
                                color: "red",
                                fontSize: "0.75rem",
                                marginTop: "4px",
                              }}
                            >
                              Item is expired
                            </div>
                          );
                        }

                        return null;
                      })()}
                    </div>
                    {expiryDate && (
                      <Grid item xs={12} md={2}>
                        <Tooltip title="Delete Expiry Date">
                          <IconButton onClick={handleClearExpiryDate}>
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} md={6}></Grid>
                {slotDetails && (
                  <Grid item xs={12} md={6}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "8px",
                      }}
                    >
                      <FormControlLabel
                        label="Drop Sensor"
                        style={{ width: "auto" }}
                        control={
                          <Switch
                            checked={dropSensor ?? true}
                            onChange={(e) => setDropSensor(e.target.checked)}
                          />
                        }
                      />
                      <FormControlLabel
                        label="Slot Lock"
                        style={{ width: "auto" }}
                        control={
                          <Switch
                            checked={error ?? false}
                            onChange={(e) => setError(e.target.checked)}
                          />
                        }
                      />
                      <FormControlLabel
                        label="Price"
                        style={{ width: "auto" }}
                        control={
                          <Switch
                            checked={price ?? false}
                            onChange={(e) => setPrice(e.target.checked)}
                          />
                        }
                      />
                    </div>
                  </Grid>
                )}
              </Grid>
            </CardContent>
            <CardHeader title="Select Product" />
            <CardContent style={{ width: "100%" }}>
              <Grid container spacing={3}>
                <Grid item xs={12} style={{ width: "100%" }}>
                  {machineRecord?.client?.id && (
                    <Grid item xs={12} style={{ width: "100%" }}>
                      <ReferenceInput
                        label="Product"
                        source="product.id"
                        reference="products"
                        filterToQuery={(searchText) => ({
                          client: machineRecord.client.id,
                          name: searchText,
                        })}
                        filter={{ client: machineRecord.client.id }}
                        perPage={9999}
                        sort={{ field: "name", order: "ASC" }}
                        fullWidth
                      >
                        <AutocompleteInput
                          optionText="name"
                          onChange={(value) => {
                            handleProductChange(value);
                            handleOnFieldChange("product.id", value);
                          }}
                          defaultValue={selectedProductId}
                          fullWidth
                          filterToQuery={(searchText) => ({ name: searchText })}
                          validate={[required("Please select a product")]}
                          style={{ width: "100%" }}
                        />
                      </ReferenceInput>
                    </Grid>
                  )}
                </Grid>
              </Grid>
              {selectedProductId && (
                <FormProvider {...productForm}>
                  <ProductForm
                    productId={selectedProductId}
                    formValues={slotDetails}
                    dirtyFields={dirtyFields}
                    modified={modified}
                    clientId={machineRecord?.client?.id}
                    onMROAccessChange={handleMROAccessChange}
                    onProductRecordChange={handleProductRecordChange}
                    machineRecord={machineRecord}
                    showPriceInput={price}
                  />
                </FormProvider>
              )}
            </CardContent>
            <CardActions style={{ width: "100%" }}>
              <Box
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Box gap={2}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={saving}
                    style={{ marginRight: "1rem" }}
                  >
                    {saving ? "Saving" : "Save"}
                  </Button>
                  <Button
                    onClick={() => navigate(`/machines/edit/${machineId}`)}
                    variant="contained"
                  >
                    Back
                  </Button>
                </Box>
                <Button
                  onClick={onRemove}
                  variant="contained"
                  disabled={removing || saving}
                  style={{ backgroundColor: "red", color: "#FFF" }}
                >
                  Remove
                </Button>
              </Box>
            </CardActions>
          </SimpleForm>
        </div>
      </_extendLayout>
    </>
  );
};

export default SlotEdit;
